import React from "react";
import { Check } from "lucide-react";

export const OptionCard = ({
  label,
  selected,
  onClick,
  multi = false,
  testId,
}) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    data-selected={selected}
    className={`group w-full text-left p-4 md:p-5 rounded-2xl border-2 transition-all duration-200 flex items-center justify-between gap-4 active:scale-[0.99] ${
      selected
        ? "border-[#FF5E1A] bg-[#FFF3ED]/85 backdrop-blur-md ring-1 ring-[#FF5E1A] cp-shadow-orange"
        : "glass hover:bg-white/65 hover:border-white/80"
    }`}
  >
    <span
      className={`text-base md:text-lg font-semibold leading-snug ${
        selected ? "text-[#FF5E1A]" : "text-[#0F172A]"
      }`}
    >
      {label}
    </span>
    <span
      className={`shrink-0 w-6 h-6 ${
        multi ? "rounded-md" : "rounded-full"
      } border-2 flex items-center justify-center transition-all ${
        selected
          ? "bg-[#FF5E1A] border-[#FF5E1A] text-white"
          : "border-white/80 bg-white/60 text-transparent group-hover:border-white"
      }`}
    >
      <Check className="w-4 h-4" strokeWidth={3} />
    </span>
  </button>
);
